export default __webpack_public_path__ + "static/good_svyaz-96a83be5fda64bfd786492190e62f212.png";